/* eslint-disable no-undef */
import {
    getCookie
} from './utils.js';

import {
    is360zhushou,
    isInAPP
} from './types';

/**
 * 判断在APP中是否登录
 * @return {promise} true 为登录 false 为未登录
 */

const checkLoginInApp = (_) => {
    return new Promise((reslove, reject) => {
        WBAPP &&
            WBAPP.invoke('is_login', function (state) {
                if (state === '0') {
                    reslove(true);
                } else if (state === '1') {
                    reslove(false);
                }
            });
    });
};

// /**
//  * 是否在APP内
//  * @Author   wangmeng
//  * @DateTime 2018-12-26
//  */
// const isInAPP = _ => {
//     // return navigator.userAgent.toLowerCase().match(/wuba/i) == 'wuba'
//     return getCookie("58ua") === "58app";
// };

/**
 * 判断两端登录
 * @param {*} login
 * @param {*} isLoginThen
 */
const isLogin = (login, isLoginThen) => {
    if (isInAPP) {
        // invoke login_mobile_dynamic 方法手机动态码登录
        // 58app判断是否登录
        WBAPP &&
            WBAPP.action.isLogin(function (state) {
                if (state === '0') {
                    console.log('登录');
                    // 已经登录
                    isLoginThen && isLoginThen();
                } else if (state === '1') {
                    // 未登录
                    login && login();
                }
            });
    } else {
        // 浏览器环境判断是否登录
        if (getCookie('PPU')) {
            // 登录
            isLoginThen && isLoginThen();
            return;
        } else {
            // 未登录
            login && login();
            return;
        }
    }
};
/**
 * app登录
 * @Author   wangmeng
 * @DateTime 2018-12-27
 */
const AppLogin = (_) => {
    return new Promise((reslove, reject) => {
        window.WBAPP.invoke('login', function (state) {
            if (state === '0') {
                reslove(true);
            } else if (state === '1') {
                reslove(false);
            } else if (state === '2') {
                reject(false);
            }
        });
    });
};

const AppMobileLogin = (_) => {
    return new Promise((reslove, reject) => {
        window.WBAPP.invoke('login_mobile_dynamic', function (state) {
            if (state === '0') {
                reslove(true);
            } else if (state === '1') {
                reslove(false);
            } else if (state === '2') {
                reslove(false);
            }
        });
    });
};
/**
 * isInstallApp
 * @Author   wangmeng
 * @DateTime 2018-12-26
 * @param    {string}   options.urlschema
 * @param    {string}   options.pkg
 * @return   {promise}
 */
const isInstallApp = ({
    urlschema,
    pkg
}) => {
    return new Promise((reslove, reject) => {
        WBAPP.action.isInstallApp({
                urlschema,
                package: pkg,
            },
            function (is_install) {
                if (is_install === '0') {
                    reslove(true);
                } else if (is_install === '1') {
                    reslove(false);
                }
            }
        );
    });
};

const openApp = ({
    urlschema,
    pkg,
    maincls
}) => {
    WBAPP.action.openApp({
        urlschema,
        package: pkg,
        maincls,
    });
};
const installApp = ({
    url,
    browser
}) => {
    WBAPP.action.installApp(url, browser);
};

/**
 * APP调起中间页 if hasapp接到指定web页 or 跳转到下载中间页
 * @Author   wangmeng
 * @DateTime 2018-12-28
 * @param    {Number}   options.pid pid
 * @param    {String}   options.url 跳转指定页面
 * @param    {title}    options.title title
 * @link http://wxc.58corp.com/pages/viewpage.action?pageId=8681013
 */

const installAppOrGoPage = ({
    pid,
    url,
    title,
    pagetype
}) => {
    let _pid = pid ? `pid=${pid}` : '';
    let _title = title ? `&title=${encodeURIComponent(title)}` : '';
    let _pagetype = pagetype ?
        `&pagetype=${encodeURIComponent(pagetype)}` :
        '&pagetype=common';
    if (is360zhushou) {
        window.location.href = `//static.58.com/job/m/topic/2019/wakeapp/360zhushou.html?curpage=${pid}&url=${encodeURIComponent(
            url
        )}${_title}`;
    }
    //此链接调起的页面 无法分享图片
    window.location.href = `//static.58.com/job/m/topic/2019/wakeapp/public.html?${_pid}&tradeline=core${_pagetype}&url=${encodeURIComponent(
        url
    )}${_title}`;
    // window.location.href = `http://down.58.com/zt/callappback.html?url=${encodeURIComponent(
    //     url
    // )}${_title}&${_pid}`;
};

/**
 * 直调 http://wxc.58corp.com/pages/viewpage.action?pageId=8681889
 */

/**
 * 跳转页面 app里调用jssdk跳转 h5 http跳转
 * 可优化 第一次运行就直接返回相关平台的方法函数重载
 * @Author   wangmeng
 * @DateTime 2018-12-28
 * @return   {}
 */
const goPage = ({
    title = '',
    isfinish = false,
    url = ''
}) => {
    if (isInAPP) {
        let content = title ?
            {
                title,
                url,
                pagetype: 'common',
                isfinish,
            } :
            {
                url,
                pagetype: 'common',
                isfinish,
            };
        WBAPP &&
            WBAPP.invoke('pagetrans', {
                action: 'pagetrans',
                tradeline: 'core',
                content,
            });
    } else {
        window.location.href = url;
        window.location.reload()
    }
};
/**
 *
 * @param {any} param0
 */
const pagetrans = ({
    tradeline,
    url,
    title,
    pagetype
} = {
    tradeline: 'core',
    url,
    title,
    pagetype: 'common',
}) => {
    if (isInAPP) {
        WBAPP &&
            WBAPP.invoke('pagetrans', {
                action: 'pagetrans',
                tradeline: tradeline,
                content: {
                    pagetype: pagetype,
                    url: url,
                    title: title,
                },
            });
    } else {}
};
/**
 * appShare
 * @Author   wangmeng
 * @DateTime 2018-12-28
 * @param    {any}   options.shareto 分享的平台 默认微信好友和朋友圈
 * @param    {object}   options.data 分享的数据
 * @return   {promise}  分享成功或失败
 */
const appShare = ({
    shareto,
    data
} = {
    shareto: 'WEIXIN,FRIENDS',
    data: {
        url: '',
        title: '',
        content: '',
        placeholder: '',
        img_url: '',
    },
}) => {
    return new Promise((reslove, reject) => {
        WBAPP &&
            WBAPP.extend.share.to(shareto, data, function (state, source) {
                if (state === '0') {
                    reslove(true);
                } else {
                    reslove(false);
                }
            });
    });
};

/**
 * 惰性载入 只在加载时判断
 * @Author   wangmeng
 * @DateTime 2019-04-20
 */
const setWebLog = (() => {
    if (isInAPP) {
        return function log({
            pageType,
            actionType,
            opts = {},
            mlog = ''
        }) {
            window.clickLogTimer && clearTimeout(window.clickLogTimer);
            
            if (WBAPP && WBAPP.action && WBAPP.action.setWeblog) {
                // 最新版埋点 10.24.0版本以上使用
                const appVersion = window.WBAPP.common.appVersion;
                if(parseInt(window.WBAPP.util.compareVersion(appVersion, "10.24.0")) >= 0){
                    let options = {
                        page_type: pageType,
                        action_type: actionType,
                        cate: "9224",
                        realtime: false,
                        top_level: false,
                        params: [window.location.href],
                        json:{
                            url:'' + window.location.origin + window.location.pathname 
                        }
                    } 

                    options = Object.assign(options,opts);
                    
                    window.WBAPP.invoke("job_weblog" , options);
                    return;
                }

                let options = Object.assign({},
                    opts, {
                        cate: '9224',
                    }, {
                        params: [window.location.href],
                    }
                );
                WBAPP.action.setWeblog(pageType, actionType, options);
                return
            } 

            window.clickLogTimer = setTimeout(() => {
                log(options);
            }, 1000);
        };
    } else {
        return function log({
            pageType,
            actionType,
            opts,
            mlog
        }) {
            window.clickLogTimer && clearTimeout(window.clickLogTimer);
            if (mlog) {
                if (typeof window.clickLog === 'function') {
                    window.clickLog('from=' + mlog);
                } else {
                    window.clickLogTimer = setTimeout(() => log(mlog), 1000);
                }
            }
        };
    }
})();

/**
 * 直调 默认调到主页 paramsObj.url协议
 * @Author   wangmeng
 * <script src="//j1.58cdn.com.cn/ztzp/2019/m/static/js/wxjs.js"></script>
 * <script src="//down.58.com/js/callWbApp_2019_min.js"></script>
 * @DateTime 2019-02-15
 * @param    {any}   dom       DOM
 * @param    {string}   type      "'protocol'" type
 * @param    {object}   paramsObj {url: url ,title: title}
 * @param    {number}   pid       pid
 * @example zhidiao(".xxx", "protocol", {url: "http://www.58.com",title: "雨桐佩奇"}, 1111);
 */
const zhidiao = (dom, type, paramsObj, pid = 751) => {
    const defaultUrl =
        'wbmain://jump/core/main?params=%7B%22tab%22%3A%22home%22%7D';
    let protocol = paramsObj.url && paramsObj.url.indexOf('wbmain://') > -1 ? paramsObj.url : `wbmain://jump/core/common?pid=${pid}&params=` +
        encodeURIComponent(JSON.stringify(paramsObj))
    window.callWbApp && window.callWbApp(dom, type, {
        jump: protocol || defaultUrl,
        pid: pid,
    });
};

const callGanJi = ({
    openUrl,
    type = 'launch'
}) => {
    window.onLaunchApp && window.onLaunchApp({
        openUrl,
        type
    })
}

/**
 *跳转微简历页面 source统计来源
 * @param {number} [source=78]
 */
const createResume = (source) => {
    WBAPP &&
        WBAPP.action.pagetrans('core', {
            pagetype: 'common', // 必填
            url: `https://jlwebapp.58.com/resume/addbaseresume?sourceid=${source}`, // 必填
            title: '发布简历', // 选填，无则会自动识别dom中的title值
            // isfinish: true
        });
};

/**
 *跳转大类页
 * @param {number} [source=78]
 */
const goDaLeiYe = () => {
    WBAPP &&
        WBAPP.invoke('pagetrans', {
            action: 'pagetrans',
            tradeline: 'job',
            content: {
                pagetype: 'fullTimeCate',
                url: 'https://zprecommend.58.com/api/jobindex',
                isfinish: false, //是否结束掉webview
            },
        });
};

const FaceAuth = (type = '3') => {
    return new Promise((reslove, reject) => {
        WBAPP &&
            WBAPP.invoke(
                'open_auth_sdk', {
                    type,
                },
                function (state) {
                    // state 0： 认证成功 1：认证失败 2 取消认证
                    console.log('state', state);
                    if (state === 0) {
                        reslove(true);
                    } else {
                        reslove(false);
                    }
                }
            );
    });
};

/**
 * 
 * @param {string} version 
 * -1 当前版本比对比版本小
 * 0 当前版本相同
 * 1 当前版本比对比版本大
 */
function compareVersion(version = '10.10.0') {
    let UA = window.navigator.userAgent
    let appVersion = window.WBAPP.common.appVersion
    if (UA.includes('GANJI')) {
        let v = UA.match(/GANJI\/(\d+(.\d+){2,})/i);
        appVersion = v && v[1];
    }
    return window.WBAPP.util.compareVersion(appVersion, version)
}
export {
    checkLoginInApp,
    isInAPP,
    isLogin,
    AppLogin,
    AppMobileLogin,
    isInstallApp,
    openApp,
    installApp,
    installAppOrGoPage,
    goPage,
    appShare,
    pagetrans,
    setWebLog,
    zhidiao,
    createResume,
    FaceAuth,
    goDaLeiYe,
    compareVersion,
    callGanJi
};